import axios from "axios";
import { API_BASE_URL } from "../config";

// Define types
export interface PathNode {
  id: string;
  caption: string;
  color?: string;
  size?: number;
  properties?: {
    node_type: string;
    description: string;
  };
}

export interface PathRelationship {
  source?: string;
  target?: string;
  caption?: string;
  type?: string;
  /** Alternative property names from Neo4j / graph APIs */
  startNode?: string;
  endNode?: string;
  from?: string;
  to?: string;
}

export interface Path {
  path: string;
  functional_summary: string;
  pathomechanisms: string[];
  relevance: string;
  nodes: PathNode[];
  relationships?: PathRelationship[];
}

export interface Mechanism {
  name: string;
  description: string | null;
  rating: number;
  short_summary: string;
  genes_in_paths?: string[];
  paths?: Path[];
  rating_reason: string;
}

export interface mechanismsData {
  [key: string]: Mechanism;
}

export interface MechanismsAPIResponse {
  status: string;
  data: mechanismsData | null;
  message?: string;
  estimated_time?: number;
}

// Client class
class MechanismsClient {
  private baseURL: string;

  constructor() {
    this.baseURL = API_BASE_URL;
  }

  async getMechanisms(
    geneSymbol: string,
    therapeuticArea?: string,
    disease?: string
  ): Promise<MechanismsAPIResponse> {
    try {
      const params: Record<string, string> = {
        gene_id: geneSymbol,
        ...(therapeuticArea ? { therapeutic_area: therapeuticArea } : {}),
        ...(disease ? { disease } : {}),
      };

      const response = await axios.get(
        `${this.baseURL}/api/tess/gene-explorer/mechanisms/`,
        {
          params,
        }
      );
      return response?.data;
    } catch (error) {
      console.error("Error fetching mechanisms:", error);
      throw error;
    }
  }

  async downloadMechanismHtml(
    geneSymbol: string,
    therapeuticArea: string,
    disease?: string
  ): Promise<Blob> {
    try {
      const params: Record<string, string> = {
        gene_id: geneSymbol,
        therapeutic_area: therapeuticArea,
        ...(disease ? { disease } : {}),
      };
      const response = await axios.get(
        `${this.baseURL}/api/tess/gene-explorer/mechanisms/downloadmechanisms`,
        { params, responseType: "blob" }
      );
      return response.data;
    } catch (error) {
      console.error("Error downloading mechanism HTML:", error);
      throw error;
    }
  }
}

export const mechanismsClient = new MechanismsClient();